import { Box } from '@mui/material';

export default function ColoredArea(props) {
	return (
		<Box
			sx={{
				width: '100%',
				borderRadius: '8px',
				padding: '24px',
				...props.styleObj,
			}}
		>
			{props.children}
		</Box>
	);
}
